/**
 * PNR Service
 * The PNR integration API
 *
 * The version of the OpenAPI document: master-7a801ca4-799560
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErrorResponseDto { 
    /**
     * HTTP status code
     */
    statusCode: number;
    /**
     * Application-specific error code
     */
    error: ErrorResponseDto_Error;
    message: string;
}
export enum ErrorResponseDto_Error {
    InvalidAuthCode = 'INVALID_AUTH_CODE',
    TokenValidationFailed = 'TOKEN_VALIDATION_FAILED',
    OrganizationIdMismatch = 'ORGANIZATION_ID_MISMATCH',
    OrganizationIdAndCodeMismatch = 'ORGANIZATION_ID_AND_CODE_MISMATCH'
};



